import { render, staticRenderFns } from "./ShowGifts.vue?vue&type=template&id=827e0f0e&scoped=true&"
import script from "./ShowGifts.vue?vue&type=script&lang=js&"
export * from "./ShowGifts.vue?vue&type=script&lang=js&"
import style0 from "./ShowGifts.vue?vue&type=style&index=0&id=827e0f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827e0f0e",
  null
  
)

export default component.exports